import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

//1 . Category API
const getPurchaseCategoryData = async (bodyData) => {
  const res = await apiClient.post("/api/v9/myBinnys/getCategory", bodyData);
  return { data: res?.data?.data?.data, totalCount: res?.data?.data?.totalCount, totalDesigncount: res?.data?.data?.totalDesignCount };
};

export const useGetPurchaseCategory = (bodyData) => {
  return useQuery({
    queryKey: ["purchaseCategory", bodyData],
    queryFn: () => getPurchaseCategoryData(bodyData),
    enabled: !!bodyData,
  });
};

//2. Sub Catgeory API

const getPurchaseSubCategoryData = async (bodyData) => {
  const res = await apiClient.post("/api/v9/myBinnys/getSubCategory", bodyData);
  return { data: res?.data?.data?.data, totalCount: res?.data?.data?.totalCount, totalDesigncount: res?.data?.data?.totalDesignCount };
};

export const useGetPurchaseSubCategory = (bodyData) => {
  return useQuery({
    queryKey: ["purchaseSubCategory", bodyData],
    queryFn: () => getPurchaseSubCategoryData(bodyData),
    enabled: !!bodyData,
  });
};

//3. Category Design API

const getPurchaseCategoryDesignData = async ({ pageParam = 1, queryKey }) => {
  const [_key, bodyData] = queryKey;

  const res = await apiClient.post("/api/v9/myBinnys/getCategoryDesign", {
    ...bodyData,
    page: pageParam,
  });

  const { designs, totalDesignCount, totalDynamicDesignCount, page, limit, totalPages } = res?.data?.data || {};

  return {
    data: designs,
    totalDesignCount,
    totalDynamicDesignCount,
    nextPage: page < totalPages ? page + 1 : undefined, // ✅ needed for infinite query
  };
};

export const useGetPurchaseCategoryDesign = (bodyData) => {
  return useInfiniteQuery({
    queryKey: ["purchaseCategoryDesigns", bodyData],
    queryFn: getPurchaseCategoryDesignData,
    enabled: !!bodyData,
    getNextPageParam: (lastPage) => lastPage?.nextPage, // ✅ correct pagination
  });
};
